export const uuid = (): string => {
  return globalThis.crypto.randomUUID();
};

export const isUuid = (value: string): boolean => {
  const regExp = new RegExp(/^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/, 'i');
  return regExp.test(value);
};
